// assets
import { DashboardOutlined, ProfileOutlined } from "@ant-design/icons";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import BusinessIcon from "@mui/icons-material/Business";
import CoPresentIcon from "@mui/icons-material/CoPresent";
import GavelIcon from "@mui/icons-material/Gavel";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import HouseSidingIcon from "@mui/icons-material/HouseSiding";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import CategoryIcon from "@mui/icons-material/Category";
import SubdirectoryArrowRightIcon from "@mui/icons-material/SubdirectoryArrowRight";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArtTrackIcon from "@mui/icons-material/ArtTrack";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import PlusOneIcon from "@mui/icons-material/PlusOne";
import WebAssetIcon from "@mui/icons-material/WebAsset";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import AttachmentIcon from "@mui/icons-material/Attachment";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import NextWeekIcon from "@mui/icons-material/NextWeek";
import DataObjectIcon from "@mui/icons-material/DataObject";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import AutoAwesomeMotionIcon from "@mui/icons-material/AutoAwesomeMotion";
import PeopleIcon from "@mui/icons-material/People";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import PollIcon from "@mui/icons-material/Poll";
import ChecklistIcon from "@mui/icons-material/Checklist";
import ChecklistRtlIcon from "@mui/icons-material/ChecklistRtl";
import RuleIcon from "@mui/icons-material/Rule";
import TocIcon from "@mui/icons-material/Toc";
import PaymentsIcon from "@mui/icons-material/Payments";
import PixIcon from "@mui/icons-material/Pix";
import ApprovalIcon from "@mui/icons-material/Approval";
import PaidIcon from "@mui/icons-material/Paid";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import MessageIcon from "@mui/icons-material/Message";
import SmsIcon from "@mui/icons-material/Sms";
import SpeakerNotesIcon from "@mui/icons-material/SpeakerNotes";
import HandshakeIcon from "@mui/icons-material/Handshake";
import HomeIcon from "@mui/icons-material/Home";
import ContactsIcon from "@mui/icons-material/Contacts";
import RouteIcon from "@mui/icons-material/Route";
import ApartmentSharpIcon from "@mui/icons-material/ApartmentSharp";
import MapSharpIcon from "@mui/icons-material/MapSharp";
import CabinOutlinedIcon from "@mui/icons-material/CabinOutlined";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import WalletIcon from "@mui/icons-material/Wallet";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import GestureOutlinedIcon from "@mui/icons-material/GestureOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import FormatListNumberedRtlIcon from "@mui/icons-material/FormatListNumberedRtl";
import EventIcon from "@mui/icons-material/Event";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import InfoIcon from "@mui/icons-material/Info";
import TwoWheelerIcon from '@mui/icons-material/TwoWheeler';

// icons
const icons = {
  DashboardOutlined,
  ProfileOutlined,
  AdminPanelSettingsIcon,
  CreditCardIcon,
  CreditScoreIcon,
  AccountBalanceIcon,
  GavelIcon,
  SettingsSuggestIcon,
  HouseSidingIcon,
  Diversity3Icon,
  ManageAccountsIcon,
  PersonAddIcon,
  PeopleAltIcon,
  SupervisedUserCircleIcon,
  CategoryIcon,
  SubdirectoryArrowRightIcon,
  ArrowForwardIosIcon,
  ArtTrackIcon,
  PlusOneIcon,
  WebAssetIcon,
  AttachFileIcon,
  NoteAddIcon,
  AttachmentIcon,
  DocumentScannerIcon,
  BusinessCenterIcon,
  AddBusinessIcon,
  WorkOutlineIcon,
  NextWeekIcon,
  DataObjectIcon,
  PersonOffIcon,
  PeopleOutlineIcon,
  AutoAwesomeMotionIcon,
  PeopleIcon,
  GroupAddIcon,
  PollIcon,
  ChecklistIcon,
  ChecklistRtlIcon,
  RuleIcon,
  TocIcon,
  PaymentsIcon,
  PixIcon,
  ApprovalIcon,
  PaidIcon,
  RequestQuoteIcon,
  AttachMoneyIcon,
  MessageIcon,
  SmsIcon,
  SpeakerNotesIcon,
  HandshakeIcon,
  BusinessIcon,
  HomeIcon,
  ContactsIcon,
  RouteIcon,
  ApartmentSharpIcon,
  MapSharpIcon,
  CabinOutlinedIcon,
  Inventory2Icon,
  WalletIcon,
  AssignmentIndIcon,
  GestureOutlinedIcon,
  AssignmentOutlinedIcon,
  FormatListNumberedRtlIcon,
  EventIcon,
  SettingsApplicationsIcon,
};
const dashboard = {
  id: "group-dashboard",
  title: "Navigation",
  type: "group",
  children: [
    {
      id: "Administration",
      title: "Administration",
      permission: "AdministrationSetup",
      icon: icons.AdminPanelSettingsIcon,
      children: [
        {
          id: "Administration-users",
          title: "Users",
          permission: "UserListing",
          url: "/dashboard/administration/users",
          icon: icons.PeopleAltIcon,
        },
        {
          id: "Administration-product-category",
          title: "Product Category",
          permission: "ProjectCategoryListing",
          url: "/dashboard/administration/product-category",
          icon: icons.Inventory2Icon,
        },
        {
          id: "Administration-apply-loan-step",
          title: "Apply Loan Step Setup",
          permission: "ProjectCategoryListing",
          url: "/dashboard/administration/apply-loan-step",
          icon: icons.Inventory2Icon,
        },
        {
          id: "Administration-fast-service",
          title: "Fast Service Setup",
          permission: "ProjectCategoryListing",
          url: "/dashboard/administration/fast-service",
          icon: icons.Inventory2Icon,
        },
        {
          id: "Administration-our-service-setup",
          title: "Our Services Setup",
          permission: "OurServiceListing",
          icon: TwoWheelerIcon,
          url: "/dashboard/administration/our-services",
        },
        {
          id: "Administration-policy-documents-setup",
          title: "Policy Document Setup",
          permission: "PolicyDocumentListing",
          icon: CoPresentIcon,
          url: "/dashboard/administration/policy-document-list",
        },
        {
          id: "Administration-customer-voice-setup",
          title: "Customer Voices Setup",
          permission: "CustomerVoiceListing",
          icon: PeopleAltIcon,
          url: "/dashboard/administration/customer-voices",
        },
        {
          id: "Administration-faq-question",
          title: "FAQ Question Setup",
          permission: "ProjectCategoryListing",
          url: "/dashboard/administration/faq-question",
          icon: icons.Inventory2Icon,
        },
        {
          id: "Administration-faq-answer",
          title: "FAQ Answer Setup",
          permission: "ProjectCategoryListing",
          url: "/dashboard/administration/faq-answer",
          icon: icons.Inventory2Icon,
        },
        {
          id: "Administration-downpayment-setup",
          title: "Down Payment Setup",
          permission: "DownPaymentSchemeListing",
          url: "/dashboard/administration/downpayment-setup",
          icon: icons.Inventory2Icon,
        },
        {
          id: "Administration-region-setup",
          title: "Region Setup",
          permission: "RegionSetupListing",
          url: "/dashboard/administration/region-setup",
          icon: icons.MapSharpIcon,
        },
        {
          id: "Administration-document-access-setup",
          title: "Document Access Setup",
          permission: "DocumentAccessSetupListing",
          url: "/dashboard/administration/document-access-setup",
          icon: icons.DocumentScannerIcon,
        },
        {
          id: "Administration-first-due-date-setup",
          title: "First Due Date Setup",
          permission: "FirstDueDateSetupListing",
          url: "/dashboard/administration/first-due-date-setup",
          icon: icons.DashboardOutlined,
        },
        {
          id: "Administration-nrc-states",
          title: "NRC States",
          permission: "NRCStateListing",
          url: "/dashboard/administration/nrc-states",
          icon: icons.ContactsIcon,
        },
        {
          id: "Administration-nrc-townships",
          title: "NRC Townships",
          permission: "NRCTownshipListing",
          url: "/dashboard/administration/nrc-townships",
          icon: icons.RouteIcon,
        },
        {
          id: "Administration-vehicle-setup",
          title: "Electronic Setup",
          permission: "VehicleSetupListing",
          url: "/dashboard/administration/vehicle-setup",
          icon: icons.DashboardOutlined,
        },
        {

          id: "Administration-dealers",
          title: "Travel Agency Setup",
          permission: "DealerListing",
          url: "/dashboard/administration/dealers",
          icon: InfoIcon,
        },
        {
          id: "Administration-application-information-set-up",
          title: "Application Information Setup",
          permission: "ApplicationInformationSetupListing",
          url: "/dashboard/administration/application-info-setup",
          icon: icons.WebAssetIcon,
        },
        {
          id: "Administration-application-information-set-up-list",
          title: "Application Information Setup List",
          permission: "ApplicationInformationSetupListing",
          url: "/dashboard/administration/application-info-setup-list",
          icon: icons.WebAssetIcon,
        },
        {
          id: "Administration-customer-bank-list",
          title: "Customer Bank",
          permission: "ApplicationInformationSetupListing",
          url: "/dashboard/administration/customer-banks",
          icon: AccountBalanceWalletIcon,
        },
        {
          id: "Administration-applications",
          title: "Applications",
          permission: "ApplicationListing",
          url: "/dashboard/administration/applications",
          icon: icons.AssignmentIndIcon,
        }
      ],
    },
  ],
};

export default dashboard;
